<template>
    <div class="col-md-2 mt-3">
        <button
            :type="type"
            :class="buttonClass"
            :disabled="disabled"
            @click="clickBtn"
        >
        {{ label }}
        </button>
    </div>
</template>
  
<script>
export default {
    name: "DynamicButton",
    props: {
        label: {
            type: String,
            default: "Add",
        },
        type: {
            type: String,
            default: "button",
        },
        color: {
            type: String,
            default: "primary",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        onClick: {
            type: Function,
            default: () => {},
        },
    },
    computed: {
        buttonClass() {
            return [
                'btn',
                `btn-${this.color}`,
                `bt-sm`,
                `mt-4`,
                { 'btn-disabled': this.disabled },
            ];
        },
    },
    methods: {
        clickBtn() {
            this.$emit('clickBtn');
        },
    },
};
</script>
  
<style scoped>
</style>
  